import React from "react";
import IconSpinner from "components/IconSpinner";
import PaychexLogoV2 from "components/PaychexLogoV2";
import IconLogoV2 from "components/IconLogoV2";

const PaychexSsoLoading = () => {
  return (
    <div className="individual-authentication paychex-sso-landing">
      <div className="secondary-auth-header">
        <span className="secondary-auth-header-logos">
          <PaychexLogoV2 />
          <span className="secondary-auth-header-plus">+</span>
          <IconLogoV2 />
        </span>

        <p className="secondary-auth-header-text">
          Icon is a retirement benefits company and a trusted partner of
          Paychex.
        </p>
        <p>Please wait while we connect your Paychex account.</p>
        <IconSpinner centered />
      </div>
    </div>
  );
};

export default PaychexSsoLoading;
